export default {
    props: {
        searchResult: {
            type: Object,
            require: true
        }
    },
    computed: {
        totalAmount() {
            return this.total.total
        },
        totalCommission() {
            return this.total.commission
        },
        services() {
            return this.searchResult.services
        },

        canRegister() {
            return this.searchResult.canRegister
        },
        
        enableCanRegister() {
            if (this.searchResult.canRegister) {
                return this.validatePhoneEmail(this.phoneEmail)
            }
            return false
        },
        wgStandAlone() {
            return !!this.$store.state.options && (this.$store.state.options.standAlone === true || this.$store.state.options.standAlone == "true")
        },
    },
    data() {
        return {
            selectedPaySystem: this.searchResult.paySystems[0],
            phoneEmail: '',
            register: true,
            saving: false,

            recalc: false,

            total: this.searchResult.total,
            totalChanged: 0,
            lastCall: 0,

            openNewTab: true,
            closeOnAccept: true
        }
    },
    methods: {
        savePayment(amounts) {
            this.saving = true
            
            let register = this.enableCanRegister && this.register
            return this.$api.savePaymentWithSumm(this.$store.state.options.providerGuid, this.selectedPaySystem.guid, amounts, this.phoneEmail || "", register)
                .then(res => {


            /*         if (this.openNewTab) {
                        top.window.open(res.url, '_blank')//.focus()
                    } else {
                        top.location.replace(res.url)
                    }
 */
                    this.postMessage("tab:open", { 
                        url: res.url,
                        newTab: this.openNewTab
                    })

                    if (this.openNewTab && !this.wgStandAlone && this.closeOnAccept) {
                        this.$router.push({
                            name: 'search'
                        })
                        this.postMessage('dialog:close')
                    }
                })
                .catch(error => {
                    this.handleError(error)
                    return error
                })
                .finally(() => {
                    this.saving = false
                })
        },
        calcTotal(amounts) {
            let date = Date.now()
/*             console.log('req: ', date) */
            this.lastCall = date
            this.recalc = true
            return this.$api.calcTotalWithSumm(this.$store.state.options.providerGuid, this.selectedPaySystem.guid, amounts)
                .then(res => {
/*                     console.log(`resp: ${date}: ${this.lastCall == date}`) */
                    if (this.lastCall == date) {
                        this.total = res
                        this.recalc = false;
                    }
                })
                .catch(error => {
                    if (this.lastCall == date) {
                        this.handleError(error)
                        this.recalc = false;
                    }
                })
        },
        handleError(error) {
            console.error(error)
            switch (error.code) {
                case 10:
                    this.showMessage(error.message)
                    break;
                    /*          case 20:
                                 this.showCaptcha()
                                 break; */
                    /*              case 30: 
              
                                    break;  */
                case 99:
                    this.showMessage("Сервис недоступен. Повторите попытку позже.")
                    break;
                default:
                    this.showMessage("Сервис недоступен. Повторите попытку позже.")
                    break;
            }
        },

        showMessage(text) {
            this.$eventBus.$emit("modal:dialog", {
                props: {
                    message: text
                }
            })
        },


        validatePhone(phone) {
            var re = /^((\+7|8)[-\s]?)?[1-9]{1}\d{2}[-\s]?\d{3}[-\s]?\d{2}[-\s]?\d{2}$/
            return re.test(phone)
        },

        validateEmail(email) {
            var re =
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        validatePhoneEmail(phoneEmail) {

            return this.validatePhone(phoneEmail) || this.validateEmail(phoneEmail)

        }


    }
}